"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedNavigation = void 0;
const utils_1 = require("../../../scripts/utils/utils");
const base_component_1 = require("../../../scripts/components/base-component");
const check_media_1 = require("../../../scripts/utils/check-media");
const debounce_1 = require("../../../scripts/utils/debounce");
class FeaturedNavigation extends base_component_1.BaseComponent {
    elementsTemplateAttribute;
    lineAttribute;
    imageAttribute;
    buttonAttribute;
    imageActiveClass;
    buttonActiveClass;
    buttonIconAttribute;
    template;
    floatingImg;
    floatingBtn;
    container;
    lines;
    images;
    buttons;
    iconPlaceholder;
    scrollingType;
    scrollingTypeAttribute;
    imageWidth;
    imageHeight;
    buttonWidth;
    buttonHeight;
    isAnimating;
    forceStopped;
    mouseIsOn;
    isMobile;
    resizeObserver;
    activeImage;
    activeButton;
    animation;
    x;
    y;
    mouseY;
    constructor() {
        super();
        this.elementsTemplateAttribute = '[data-elements-template]';
        this.lineAttribute = '[data-navigation-line]';
        this.imageAttribute = '[data-navigation-line-image]';
        this.buttonAttribute = '[data-navigation-line-button]';
        this.imageActiveClass = 'featured-navigation__link-image--active';
        this.buttonActiveClass = 'featured-navigation__btn--active';
        this.buttonIconAttribute = '[data-button-without-text]';
        this.scrollingTypeAttribute = 'data-scrolling-type';
        this.template = this.querySelector(this.elementsTemplateAttribute);
        if (this.template) {
            this.floatingImg = this.template.content.querySelector(this.imageAttribute);
            this.floatingBtn = this.template.content.querySelector(this.buttonAttribute);
            this.container = this.querySelector('.container');
            this.lines = this.querySelectorAll(this.lineAttribute);
            this.images = (0, utils_1.$list)(this.imageAttribute, this);
            this.buttons = (0, utils_1.$list)(this.buttonAttribute, this);
            this.iconPlaceholder = (0, utils_1.$el)(this.buttonIconAttribute, this)?.firstElementChild?.cloneNode(true);
            this.scrollingType = this.getAttribute(this.scrollingTypeAttribute);
            this.isAnimating = false;
            this.forceStopped = true;
            this.isMobile = (0, check_media_1.isMobile)();
            this.resizeObserver = new ResizeObserver(this.handleResize);
            this.resizeObserver.observe(this);
        }
    }
    connectedCallback() {
        if (!this.isMobile && this.getAttribute("data-enable-floating-elements") == 'true') {
            this.initDesktop();
        }
    }
    disconnectedCallback() {
        this.deInitDesktop();
    }
    initDesktop = () => {
        this.initFloatingElements();
        this.setRects(this.floatingImg, this.buttons[0]);
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.lines.forEach(line => {
            if (this.scrollingType === 'none') {
                line
                    .querySelector('.featured-navigation__link-text')
                    .addEventListener('mouseenter', this.handleMouseEnterLine);
                line
                    .querySelector('.featured-navigation__link-text')
                    .addEventListener('mouseleave', this.handleMouseLeaveLine);
            }
            else {
                line.addEventListener('mouseenter', this.handleMouseEnterLine);
            }
        });
    };
    deInitDesktop = () => {
        this.deinitFloatingElements();
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.lines.forEach(line => {
            if (this.scrollingType === 'none') {
                line
                    .querySelector('.featured-navigation__link-text')
                    .removeEventListener('mouseenter', this.handleMouseEnterLine);
                line
                    .querySelector('.featured-navigation__link-text')
                    .removeEventListener('mouseleave', this.handleMouseLeaveLine);
            }
            else {
                line.removeEventListener('mouseenter', this.handleMouseEnterLine);
            }
        });
        document.removeEventListener('mousemove', this.handleMouseMove);
    };
    initFloatingElements = () => {
        this.activeImage = this.floatingImg.cloneNode(true);
        this.activeButton = this.floatingBtn.cloneNode(true);
        this.container.appendChild(this.activeImage);
        this.container.appendChild(this.activeButton);
        this.scaleDown();
    };
    deinitFloatingElements = () => {
        this.activeImage.remove();
        this.activeButton.remove();
    };
    handleMouseEnterLine = (event) => {
        const { targetImage, targetButton } = this.getTargetImageAndButton(event);
        this.replaceFloatingElementsData(targetImage, targetButton);
        this.forceStopped = false;
        if (!this.isAnimating) {
            this.handleMouseEnter(event);
        }
    };
    handleMouseLeaveLine = () => {
        this.scaleDown();
    };
    replaceFloatingElementsData = (imageData, buttonData) => {
        if (imageData) {
            this.activeImage.src = imageData?.src;
            this.activeImage.srcset = imageData?.srcset;
            this.activeImage.style.maxHeight = `${imageData.getBoundingClientRect().height}px`;
            this.toggleImageActiveClass(this.activeImage, 'add');
            this.activeImage.style.opacity = '1';
        }
        else {
            this.toggleImageActiveClass(this.activeImage, 'add');
            this.activeImage.style.opacity = '0';
        }
        if (buttonData) {
            if (buttonData.hasAttribute('data-button-without-text')) {
                this.activeButton.replaceChildren(this.iconPlaceholder);
            }
            else {
                this.activeButton.textContent = buttonData.textContent;
            }
            this.activeButton.className = `${buttonData.className} ${this.buttonActiveClass}`;
            this.activeButton.href = buttonData.href;
            this.toggleButtonActiveClass(this.activeButton, 'add');
            this.activeButton.style.opacity = '1';
        }
        else {
            this.activeButton.style.opacity = '0';
        }
        this.scaleUp();
        this.setRects(imageData, buttonData);
    };
    handleMouseEnter = (event) => {
        this.activeImage.style.translate = `${event.clientX - this.imageWidth}px ${event.clientY - this.imageHeight}px`;
        this.activeButton.style.translate = `${event.clientX - this.buttonWidth}px ${event.clientY - this.buttonHeight}px`;
        if (!this.mouseIsOn) {
            document.addEventListener('mousemove', this.handleMouseMove);
            this.toggleScrollListener(true);
        }
        this.mouseIsOn = true;
    };
    handleMouseLeave = () => {
        this.scaleDown();
        this.toggleScrollListener(false);
    };
    toggleScrollListener = (add) => {
        if (add) {
            this.addListener(window, 'scroll', this.handleScroll);
        }
        else {
            this.removeListener(window, 'scroll', this.handleScroll);
        }
    };
    handleScroll = (0, debounce_1.debounce)(() => {
        const { top, bottom } = this.getBoundingClientRect();
        if (this.mouseY < top || this.mouseY > bottom) {
            this.handleMouseLeave();
        }
    }, 100);
    handleMouseMove = (event) => {
        if (!this.forceStopped) {
            const target = event.target;
            if (target === this.container || !target.closest('featured-navigation')) {
                this.handleMouseLeave();
            }
            const { x, y, mouseY } = this.getMouseCoordinates(event.clientX, event.clientY);
            this.x = x;
            this.y = y;
            this.mouseY = mouseY;
            if (!this.isAnimating) {
                this.startAnimation();
            }
        }
    };
    startAnimation = () => {
        this.isAnimating = true;
        this.animation = requestAnimationFrame(this.tick);
    };
    stopAnimation = () => {
        this.isAnimating = false;
        cancelAnimationFrame(this.animation);
        const cancelAnimation = this.activeImage.style.scale === '0' &&
            this.activeButton.style.scale === '0';
        if (cancelAnimation) {
            this.forceStopped = true;
            this.toggleImageActiveClass(this.activeImage, 'remove');
            this.toggleButtonActiveClass(this.activeButton, 'remove');
            document.removeEventListener('mousemove', this.handleMouseMove);
            this.mouseIsOn = false;
        }
    };
    tick = (time) => {
        const { x, y, width } = this.activeImage
            ? this.activeImage.getBoundingClientRect()
            : this.activeButton.getBoundingClientRect();
        const targetXimage = +(this.x - x).toFixed(3);
        const targetYimage = +(this.y - y).toFixed(3);
        const targetXbutton = targetXimage + this.imageWidth - this.buttonWidth;
        const targetYbutton = targetYimage + this.imageHeight - this.buttonHeight;
        this.draw(targetXimage + x, targetYimage + y, targetXbutton + x, targetYbutton + y);
        if (targetXimage !== 0 && targetYimage !== 0 && width > 0) {
            this.animation = requestAnimationFrame(this.tick);
        }
        else {
            this.stopAnimation();
        }
    };
    draw = (imageX, imageY, buttonX, buttonY) => {
        this.activeImage.style.translate = `${imageX}px ${imageY}px`;
        this.activeButton.style.translate = `${buttonX}px ${buttonY}px`;
    };
    getTargetImageAndButton = (event) => {
        const targetLine = event.currentTarget;
        const id = targetLine.dataset.navigationLine || targetLine.dataset.lineId;
        const targetImage = this.images.find(img => img.dataset.navigationLineImage === id);
        const targetButton = this.buttons.find(btn => btn.dataset.navigationLineButton === id);
        return { targetImage, targetButton };
    };
    setRects = (targetImage, targetButton) => {
        this.imageWidth = this.activeImage.offsetWidth / 2;
        this.imageHeight = targetImage
            ? targetImage.scrollHeight / 2
            : this.activeImage.offsetHeight / 2;
        this.buttonWidth = targetButton?.offsetWidth / 2;
        this.buttonHeight = targetButton?.offsetHeight / 2;
    };
    getMouseCoordinates = (x, y) => {
        return {
            x: x - this.imageWidth,
            y: y - this.imageHeight,
            mouseY: y,
        };
    };
    toggleButtonActiveClass = (element, action) => {
        element?.classList.toggle(this.buttonActiveClass, action === 'add');
    };
    toggleImageActiveClass = (element, action) => {
        element?.classList.toggle(this.imageActiveClass, action === 'add');
    };
    scaleUp = () => {
        this.activeImage.style.scale = '1';
        this.activeButton.style.scale = '1';
    };
    scaleDown = () => {
        this.activeImage.style.scale = '0';
        this.activeButton.style.scale = '0';
    };
    handleResize = (0, debounce_1.debounce)(() => {
        if (this.getAttribute("data-enable-floating-elements") == 'true') {
            if ((0, check_media_1.isMobile)() === this.isMobile) {
                return;
            }
            if ((0, check_media_1.isMobile)()) {
                this.deInitDesktop();
            }
            else {
                this.initDesktop();
            }
            this.isMobile = (0, check_media_1.isMobile)();
        }
    }, 200);
}
exports.FeaturedNavigation = FeaturedNavigation;
